// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-entity-group {
    width: 100% !important;
    /* Ensure full width */
    padding: 0 !important;
    /* Remove padding */
    margin: 0 !important;
    /* Remove margin */
}

.custom-container {
    max-width: none !important;
    /* Remove max-width */
}

@media (min-width: 1536px) {
    .custom-container {
        max-width: none !important;
        /* Remove max-width */
    }
}

/* ag-action-header */

/* Right-align the Action column header text only */
.ag-action-header .ag-header-cell-label,
.ag-action-header .ag-header-group-cell-label {
    justify-content: center !important;
    text-align: right !important;
}`, "",{"version":3,"sources":["webpack://./src/components/GroupEntity/GroupEntity.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;AACJ;;AAEA,qBAAqB;;AAErB,mDAAmD;AACnD;;IAEI,kCAAkC;IAClC,4BAA4B;AAChC","sourcesContent":[".ag-entity-group {\n    width: 100% !important;\n    /* Ensure full width */\n    padding: 0 !important;\n    /* Remove padding */\n    margin: 0 !important;\n    /* Remove margin */\n}\n\n.custom-container {\n    max-width: none !important;\n    /* Remove max-width */\n}\n\n@media (min-width: 1536px) {\n    .custom-container {\n        max-width: none !important;\n        /* Remove max-width */\n    }\n}\n\n/* ag-action-header */\n\n/* Right-align the Action column header text only */\n.ag-action-header .ag-header-cell-label,\n.ag-action-header .ag-header-group-cell-label {\n    justify-content: center !important;\n    text-align: right !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
